import { createFileRoute } from "@tanstack/react-router";

import { ProductsPage } from "@/components/Pages/Products";

export const Route = createFileRoute("/_guard/products/")({
  component: ProductsPage,
});
